// Cuidados Babybib (os do cartão que vai com cada peça), com ícones desenhados em linha suave.
const Icon = ({ children }) => (
  <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{children}</svg>
);

const Wash = () => (
  <Icon>
    <path d="M3.5 11.5h17l-1.7 6.3a2.2 2.2 0 0 1-2.1 1.7H7.3a2.2 2.2 0 0 1-2.1-1.7z" />
    <path d="M7 14.8c1.2-1 2.3-1 3.5 0s2.3 1 3.5 0 2.3-1 3 0" />
    <circle cx="9" cy="7.6" r="1.5" /><circle cx="13.2" cy="5.2" r="1.1" /><circle cx="16" cy="8.2" r="1.3" />
  </Icon>
);
const Sun = () => (
  <Icon>
    <circle cx="12" cy="12" r="3.6" />
    {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => (
      <path key={a} d="M12 3.6v1.9" transform={`rotate(${a} 12 12)`} />
    ))}
  </Icon>
);
const Iron = () => (
  <Icon>
    <path d="M3.5 18.5h17c0-5.2-3-8.8-7.5-8.8H10A3.5 3.5 0 0 0 6.5 13.2v5.3" />
    <path d="M10.5 14h4.5" />
    <path d="M8 7.200c.8-.7.8-1.500 0-2.200M12 7.200c.8-.7.8-1.500 0-2.200" />
  </Icon>
);

const Item = ({ icon, title, children }) => (
  <li className="flex gap-3">
    <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-linen text-taupe-strong">{icon}</span>
    <div className="min-w-0">
      <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ink">{title}</p>
      <p className="mt-0.5 text-sm leading-relaxed text-taupe">{children}</p>
    </div>
  </li>
);

// `personalized`: a peça leva nome, por isso avisa-se para não engomar essa zona.
export function CareGuide({ personalized = false }) {
  return (
    <ul className="space-y-4" data-testid="product-care">
      <Item icon={<Wash />} title="Lavagem">Lavar, de preferência à mão, para maior durabilidade da peça.</Item>
      <Item icon={<Sun />} title="Secagem">Deixar secar ao ar. Não colocar na máquina de secar.</Item>
      <Item icon={<Iron />} title="Engomar">
        Engomar a baixa temperatura. Proteger os tecidos com um pano ou papel vegetal{personalized ? " e não passar a zona da personalização" : ""}.
      </Item>
    </ul>
  );
}
